import { createModalStore } from '@/shared/lib/modal';

type RenameGlossaryModalState = {
  name: string;
  glossaryId: string;
};

const initialState: RenameGlossaryModalState = {
  name: '',
  glossaryId: '',
};

export const useRenameGlossaryModalStore = createModalStore(initialState);
